import * as React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

import { config } from '~/config';
import { appPaths, authPaths } from '~/routes/app-paths';

const {
  app: { version },
} = config;

interface AppMetadataProps {
  path: string;
}

export const useGetTitleFromPath = (path: string) => {
  const { t } = useTranslation(['seo']);

  const titles = {
    [appPaths.base]: t('seo:alfred.title'),
    [authPaths.login]: t('seo:login.title'),
  };
  return titles[path] || t('seo:alfred.title');
};

export const AppMetadata = ({ path }: AppMetadataProps) => {
  const title = useGetTitleFromPath(path);

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="tog-version" content={version} />
      <meta property="og:title" content={title} />
      <meta property="og:url" content={config.urls.root} />
      <meta property="og:type" content="website" />
      <meta property="og:locale" content="en_GB" />
      <meta property="og:image:alt" content={title} />
      <meta property="og:image:type" content="image/png" />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="628" />
    </Helmet>
  );
};
